import { RotationModel } from '../utils';
import { ReactElement } from 'react';
import BasicTooltip from '../../tooltips/basic-tooltip/BasicTooltip';
import { ObjectType } from '@dmc/ui';
import { useObjectTypeMarkerIcon } from '../useObjectTypeMarkerIcon';
import { useObjectMarkerTooltipOffset } from '../useObjectMarkerTooltipOffset';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import { ModelWithId } from '@casops/store/apis/commonModels';

export interface AssetMarkerProps extends RotationModel, ModelWithId {
  obj: ObjectType;
  label: string;
}

export const AssetMarker = ({
  id,
  position,
  heading,
  obj,
  label,
}: AssetMarkerProps): ReactElement => {
  const { icon, width, height } = useObjectTypeMarkerIcon(obj);

  const offset = useObjectMarkerTooltipOffset({
    heading,
    width,
    height,
    isSvgObjectTypeIcon: obj !== ObjectType.Unknown,
  });

  return (
    <RotatableMarker key={id} icon={icon} position={position} heading={heading}>
      <BasicTooltip key={id} text={label} permanent={true} offset={offset} />
    </RotatableMarker>
  );
};
